<template>
  <div>
    <template>
      <b-toast
        id="inPracticeToast"
        :variant="toastVariant"
        toaster="b-toaster-top-center"
        :body-class="'h4 text-center'"
        style="padding:0.25rem; max-width:500px;"
        solid
        no-auto-hide
        no-close-button
      >{{ msgInPractice }}</b-toast>
    </template>
    <b-overlay :show="fetching" spinner-variant="success" spinner-type="grow" rounded="sm">
      <b-overlay :show="submitting" spinner-variant="success" spinner-type="grow" rounded="sm">
        <PageWrapper :items="items" :fields="infoFields">
          <template v-slot:content>
            <div class="game-area">
              <div
                :class="[
                'exercise-groups-container',
                currentLesson && currentLesson.exercise_string_one.length === 27 ? 'long-item' : currentLesson.exercise_string_one.length === 16 ? 'group3' : null
              ]"
                v-for="(group, key, index) in EXERCISESTRING"
                v-bind:key="index"
              >
                <div class="exercise-group">
                  <BasicAndIntermediateTypingItem
                    v-for="letter in group"
                    :key="letter.position"
                    :letter="letter.character"
                    :itemState="letter.state"
                    :input="letter.input"
                  />
                </div>
              </div>
            </div>
          </template>
          <template v-slot:other-buttons>
            <b-button
              class="custom-button three"
              style="margin-bottom: 10px"
              @click="showRuleDescriptionModal"
            >{{ $t('Common.ruleDescription') }}</b-button>
            <b-button
              v-show="currentLesson.video_1 && currentLesson.video_1.length > 0"
              class="custom-button three"
              style="margin-bottom: 10px"
              @click="playVideo(currentLesson.video_1)"
            >{{ $t('Typing.playVideo1') }}</b-button>
            <b-button
              v-show="currentLesson.video_2 && currentLesson.video_2.length > 0"
              class="custom-button three"
              style="margin-bottom: 10px"
              @click="playVideo(currentLesson.video_2)"
            >{{ $t('Typing.playVideo2') }}</b-button>
            <b-button
              class="custom-button end-button"
              @click="showAskLeaveModal"
            >{{ $t('Common.endAndLeave') }}</b-button>
          </template>
        </PageWrapper>

        <RemindModal
          :modalName="'remindModal'"
          :modalHeight="remindModalHeight+'px'"
          ref="remindModal"
        >
          <template v-slot:header>
            <span>{{ remindModalHeader }}</span>
          </template>
          <template v-slot:body="{ highlight }">
            <div v-html="highlight(remindModalBody)"></div>
            <div v-if="remindErrorPairs.length > 0" v-html="remindErrorPairs"></div>
          </template>
          <template v-slot:buttons>
            <b-row>
              <b-col md="1" sm="0"></b-col>
              <b-col md="10" sm="12">
                <b-button
                  class="custom-button four"
                  style="width:200px !important;"
                  @click="hideRemindModal"
                >{{$t('Typing.gotIt')}} (Space)</b-button>
              </b-col>
              <b-col md="1" sm="0"></b-col>
            </b-row>
          </template>
        </RemindModal>

        <RemindModal :modalName="'askLeaveModal'" :modalHeight="'150px'" ref="askLeaveModal">
          <template v-slot:header>
            <span>{{ remindModalHeader }}</span>
          </template>
          <template v-slot:body>
            <p>{{ remindModalBody }}</p>
          </template>
          <template v-slot:buttons>
            <b-row>
              <b-col md="1" sm="0"></b-col>
              <b-col md="5" sm="6">
                <b-button class="custom-button five" @click="endAndLeave">{{$t('Common.yes')}}</b-button>
              </b-col>
              <b-col md="5" sm="6">
                <b-button
                  class="custom-button four"
                  @click="closeAskLeaveModal"
                >{{$t('Common.cancel')}}</b-button>
              </b-col>
              <b-col md="1" sm="0"></b-col>
            </b-row>
          </template>
        </RemindModal>

        <AchievementModal
          :modalName="'lastRecordModal'"
          :headerText="headerText"
          :score="displayScore"
          :lessonName="items"
          :extraText="''"
          ref="lastRecordModal"
        >
          <template v-slot:buttons>
            <b-row>
              <b-col md="1" sm="0"></b-col>
              <b-col md="10" sm="12">
                <b-button
                  class="custom-button four"
                  style="width:200px !important;"
                  @click="hideLastRecordModal"
                >{{$t('Typing.gotIt')}} (Space)</b-button>
              </b-col>
              <b-col md="1" sm="0"></b-col>
            </b-row>
          </template>
        </AchievementModal>

        <AchievementModal
          :modalName="'scoreModal'"
          :headerText="headerText"
          :score="displayScore"
          :lessonName="items"
          ref="scoreModal"
        >
          <template v-slot:buttons>
            <b-row>
              <b-col md="1"></b-col>
              <b-col md="5">
                <b-button
                  class="custom-button four"
                  @click="nextLevelHandler"
                >{{$t('Typing.nextLevel')}} (n)</b-button>
              </b-col>
              <b-col md="5">
                <b-button
                  class="custom-button five"
                  @click="backToMenuHandler"
                >{{$t('Common.backToMenu')}} (b)</b-button>
              </b-col>
              <b-col md="1"></b-col>
            </b-row>
          </template>
        </AchievementModal>

        <div v-show="toShowVideo" class="video-modal">
          <b-icon icon="x" font-scale="2" @click="closeVideo"></b-icon>
          <b-embed
            type="video"
            aspect="4by3"
            :src="videoUrl"
            style="margin-top:-50px;"
            controls
            controlslist="nodownload"
            allowfullscreen
            autoplay
            oncontextmenu="return false;"
          ></b-embed>
        </div>
      </b-overlay>
    </b-overlay>
  </div>
</template>

<script lang='js'>
import Vue from 'vue'
import { mapState, mapGetters } from 'vuex'
import hotkeys from 'hotkeys-js'
import accurateInterval from 'accurate-interval'
import { exerciseString54 } from '@/util/string'
import { secondToHMS } from '@/util/time'
import { roundDecimal } from '@/util/math'
import SafeAudio from '@/util/SafeAudio'
import BasicAndIntermediateTypingItem from '@/components/Typing/BasicAndIntermediateTypingItem'
import PageWrapper from '@/components/PageWrapper/PageWrapper.vue'
import RemindModal from '@/components/CustomModal/RemindModal.vue'
import AchievementModal from '@/components/CustomModal/AchievementModal.vue'

const TIMER_STEP = 100

const TypingCombineIntermediate = Vue.extend({
  name: 'TypingCombineIntermediate',
  components: {
    PageWrapper,
    BasicAndIntermediateTypingItem,
    RemindModal,
    AchievementModal
  },
  props: {
    lessonId: {
      type: [Number, String],
      required: true
    },
    currentLesson: {
      type: Object
    }
  },
  beforeMount () {
    window.addEventListener('beforeunload', this.preventNav)
  },
  mounted () {
    if (!this.currentLesson) {
      this.$router.replace({ path: '/typing' })
      return
    } else {
      localStorage.lastTypingActive = '2'
      this.$store.dispatch('typing/fetchLessonOtherInformation', {
        lesson_category: 'combine_intermediate',
        lesson_id: this.currentLesson.lesson_id
      }).then((response) => {
        if (this.lessonOtherInformation && this.lessonOtherInformation.last_record) {
          this.showLastRecord()
        } else {
          this.showDescription()
        }
      })
    }

    document.addEventListener('keydown', this.typingEventHandler)

    hotkeys('backspace', (e) => {
      e.preventDefault()
    })

    this.resetTypingLesson()
    this.shuffleExerciseString()
    this.encourageTexts = this.$t('Typing.encourageTexts')
  },
  watch: {
    isRestTime (newValue) {
      if (newValue) {
        this.stopTimer()
      } else if (this.isGameStart) {
        this.startTimer()
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    window.removeEventListener('beforeunload', this.preventNav)
    if (this.askBeforeLeave) {
      const answer = window.confirm(this.$t('Common.alertLeavingPage'))
      if (answer) {
        this.resetTypingLesson()
        next()
        // window.location.reload()
      } else {
        next(false)
      }
    } else {
      this.resetTypingLesson()
      next()
    }
  },
  beforeDestroy () {
    this.msgInPractice = ''
    this.$bvToast.hide('inPracticeToast')
    document.removeEventListener('keydown', this.typingEventHandler)
    hotkeys.unbind('backspace')
    this.stopTimer()
  },
  data () {
    return {
      items: [
        {
          label: this.$t('AppLayout.typingTitle'),
          link: 'typing'
        },
        {
          label: this.$t('Typing.combine') + this.$t('Typing.practice'),
          link: 'typing',
          activeTab: 2
        },
        {
          label: this.$t('Typing.intermediate') + this.currentLesson.lesson_name
        }
      ],
      remindModalHeader: '',
      remindModalBody: '',
      remindModalHeight: 200,
      headerText: '',
      displayScore: '',
      videoUrl: '',
      toShowVideo: false,
      askLeaveModalIsHidden: true,
      lastRecordModalIsHidden: true,
      remindModalIsHidden: true,
      clearModalIsHidden: true,
      practiceTimes: 0,
      correctTimes: 0,
      correctHits: 0,
      incorrectHits: 0,
      bestUsedTime: null,
      timer: 0,
      timeElapsed: null,
      completeUsedTime: 0,
      practiceResult: '',
      shuffledExerciseString: [[]],
      errorKeys: {},
      errorKeyPairs: {},
      letterTotalCount: {},
      remindErrorPairs: '',
      cursorPosition: 0,
      inputLetter: '',
      isGameStart: false,
      isLockInput: false,
      isCurrentPracticeCorrect: true,
      isExiting: false,
      askBeforeLeave: true,
      msgInPractice: '',
      currentIncorrectHits: 0,
      previousIncorrectHits: 0,
      incorrectKeys: [],
      toastVariant: 'primary',
      encourageTexts: [],
      encourageTextIndex: 0
    }
  },
  computed: {
    ...mapState({
      lessonOtherInformation: state => state.typing.lessonOtherInformation,
      submitting: state => state.typing.submitting,
      fetching: state => state.typing.fetching,
      finish: state => state.typing.finish,
      isRestTime: state => state.studyOrBreak.isRestTime
    }),
    ...mapGetters({
      currentUser: 'auth/getBasicInfo'
    }),
    infoFields () {
      return [
        {
          label: this.$t('Typing.bestUsedTimeFromHistory'),
          value:
            (this.bestUsedTimeFromHistory
              ? this.bestUsedTimeFromHistory.toFixed(1)
              : '0') +
            ' ' +
            this.$t('Common.second')
        },
        {
          label: this.$t('Typing.bestUsedTime'),
          value:
            (this.bestUsedTime ? this.bestUsedTime.toFixed(1) : '0') +
            ' ' +
            this.$t('Common.second')
        },
        {
          label: this.$t('Typing.completeUsedTime'),
          value: this.totalTimeUsed
        },
        {
          label: this.$t('Typing.elapsedTime'),
          value:
            (this.elapsedTime ? this.elapsedTime.toFixed(1) : '0') +
            ' ' +
            this.$t('Common.second')
        },
        {
          label: this.$t('Typing.practiceTimes'),
          value: '' + this.practiceTimes
        },
        {
          label: this.$t('Typing.correctTimes'),
          value: '' + this.correctTimes
        }
      ]
    },
    EXERCISESTRING () {
      let counter = 0
      if (this.shuffledExerciseString.length > 0) {
        return this.shuffledExerciseString.map((letters) => {
          return letters.map((letter) => {
            const position = counter
            counter++
            let state = 'completed'
            if (position > this.cursorPosition) {
              state = 'hidden'
            } else if (position === this.cursorPosition) {
              state = 'error'
            }
            return {
              character: letter,
              state: state,
              input: position === this.cursorPosition ? this.inputLetter : null,
              position: position
            }
          })
        })
      }
      return {}
    },
    elapsedTime () {
      return Math.round((this.timeElapsed / 100)) / 10
    },
    totalTimeUsed () {
      return secondToHMS(this.completeUsedTime, this.$t('Common.hour'), this.$t('Common.minute'), this.$t('Common.second'))
    },
    bestUsedTimeFromHistory () {
      if (this.lessonOtherInformation &&
      this.bestUsedTime &&
      this.lessonOtherInformation.best_used_time_from_history &&
      this.bestUsedTime < this.lessonOtherInformation.best_used_time_from_history) {
        return this.bestUsedTime
      }
      if (this.lessonOtherInformation &&
      !this.lessonOtherInformation.best_used_time_from_history) {
        return this.bestUsedTime
      }
      return this.lessonOtherInformation && this.lessonOtherInformation.best_used_time_from_history !== 9999999 ? this.lessonOtherInformation.best_used_time_from_history : null
    }
  },
  methods: {
    preventNav (event) {
      event.preventDefault()
      event.returnValue = ''
    },
    showDescription () {
      if (!this.currentLesson.showDescription) {
        return
      }

      this.showRuleDescriptionModal()
    },
    showRuleDescriptionModal () {
      let ruleDescription = this.$t(
        'Typing.typingCombineIntermediateLessonDescription',
        [this.currentLesson.threshold_frequency + this.currentLesson.threshold_frequency_to_mix]
      )

      this.remindModalHeader = this.$t('Common.ruleDescription')
      this.remindModalBody = ruleDescription
      this.remindModalHeight = 200
      this.$refs.remindModal.showModal()
      this.remindModalIsHidden = false
    },
    showLastRecord () {
      if (!this.lessonOtherInformation.last_record) {
        return
      }
      const lastRecord = this.lessonOtherInformation.last_record
      this.displayScore = this.$t('Typing.welcomeBack')
      this.headerText = this.$t('Typing.lastRecord')
      const lastRecordFields = [
        {
          label: this.$t('Typing.lastRecordBestUsedTime'),
          value:
            (lastRecord.best_used_time === '9999999'
              ? '0'
              : lastRecord.best_used_time) +
            ' ' +
            this.$t('Common.second')
        },
        {
          label: this.$t('Typing.completeUsedTime'),
          value: secondToHMS(
            lastRecord.complete_used_time,
            this.$t('Common.hour'),
            this.$t('Common.minute'),
            this.$t('Common.second')
          )
        },
        {
          label: this.$t('Typing.practiceTimes'),
          value: '' + lastRecord.practice_times
        },
        {
          label: this.$t('Typing.correctTimes'),
          value: '' + lastRecord.correct_times
        },
        {
          label: this.$t('Typing.correctRate'),
          value: roundDecimal(lastRecord.correct_rate * 100, 2) + '%'
        }
      ]
      this.$refs.lastRecordModal.showModal(lastRecordFields, true)
      this.lastRecordModalIsHidden = false
    },
    hideLastRecordModal () {
      this.$refs.lastRecordModal.closeModal()
      this.lastRecordModalIsHidden = true
    },
    typingEventHandler (event) {
      if (event.repeat || this.isRestTime) {
        return
      }
      if (!this.clearModalIsHidden) {
        if (event.key === 'n') {
          this.nextLevelHandler()
        } else if (event.key === 'b') {
          this.backToMenuHandler()
        }
      } else if (!this.remindModalIsHidden) {
        if (event.key === ' ') {
          this.hideRemindModal()
        }
      } else if (!this.lastRecordModalIsHidden) {
        if (event.key === ' ') {
          this.hideLastRecordModal()
        }
      } else if (!this.askLeaveModalIsHidden) {
        if (event.key === 'b') {
          this.endAndLeave()
        } else if (event.key === 'Enter') {
          this.closeAskLeaveModal()
        }
      } else {
        this.checkUserInputLetter(event.key)
      }
    },
    resetTypingLesson () {
      this.practiceTimes = 0
      this.correctTimes = 0
      this.correctHits = 0
      this.incorrectHits = 0
    },
    shuffleExerciseString () {
      if (this.currentLesson &&
      this.currentLesson.exercise_string_one.length > 0 &&
      this.currentLesson.exercise_string_two.length > 0) {
        // 進入左右混合之前
        if (this.correctTimes < this.currentLesson.threshold_frequency_to_mix) {
          const exerciseStringOne = this.currentLesson.exercise_string_one
          this.shuffledExerciseString = exerciseString54(exerciseStringOne)
        } else {
          const exerciseStringTwo = this.currentLesson.exercise_string_two
          this.shuffledExerciseString = exerciseString54(exerciseStringTwo)
        }

        const finalShuffedExerciseString = this.shuffledExerciseString.map((groupArray) => {
          return groupArray.join('')
        }).join('')

        for (let i = 0; i < finalShuffedExerciseString.length; i++) {
          const letter = finalShuffedExerciseString[i]
          if (this.letterTotalCount[letter] === undefined) {
            this.letterTotalCount[letter] = 1
          } else {
            this.letterTotalCount[letter] += 1
          }
        }
      }
    },
    checkUserInputLetter (key) {
      if (this.isLockInput) {
        return
      }
      if (key.length !== 1) {
        return
      }
      if (!this.currentLesson) {
        return
      }
      this.inputLetter = key
      if (this.cursorPosition === 0 && !this.isGameStart) {
        this.$store.dispatch('typing/startGame')
        this.previousIncorrectHits = this.currentIncorrectHits
        this.currentIncorrectHits = 0
        this.incorrectKeys = []
        this.isGameStart = true
        this.timeElapsed = 0
        this.startTimer()
      }
      const exerciseString = this.shuffledExerciseString.map((groupArray) => {
        return groupArray.join('')
      }).join('')
      const currentLetter = exerciseString[this.cursorPosition]
      if (currentLetter === this.inputLetter) {
        this.cursorPosition += 1
        this.inputLetter = ''
        this.correctHits += 1
        if (this.cursorPosition === exerciseString.length / 2) {
          this.msgInPractice = ''
          this.$bvToast.hide('inPracticeToast')
        }
      } else {
        this.isCurrentPracticeCorrect = false
        this.incorrectHits += 1
        this.currentIncorrectHits += 1
        if (!this.incorrectKeys.includes(exerciseString[this.cursorPosition])) {
          this.incorrectKeys.push(exerciseString[this.cursorPosition])
        }

        let pair = currentLetter + '&&' + this.inputLetter
        if (this.errorKeyPairs[pair] === undefined) {
          this.errorKeyPairs[pair] = 1
        } else {
          this.errorKeyPairs[pair] += 1
        }

        if (this.errorKeys[currentLetter] === undefined) {
          this.errorKeys[currentLetter] = 1
        } else {
          this.errorKeys[currentLetter] += 1
        }
        this.playIncorrectSound()
      }

      if (this.cursorPosition === exerciseString.length) {
        this.practiceComplete()
      }
    },
    practiceComplete () {
      this.stopTimer()
      this.isLockInput = true
      this.isGameStart = false

      this.updateResult()
      this.checkAccuracyAndNotice().then(() => {
        if (!this.finish) {
          this.isLockInput = false
          this.inputLetter = ''
          this.cursorPosition = 0
          this.isCurrentPracticeCorrect = true
          this.shuffleExerciseString()
        }
      })
    },
    updateResult () {
      this.practiceTimes += 1
      this.correctTimes += this.isCurrentPracticeCorrect ? 1 : 0
      this.completeUsedTime += this.elapsedTime
      if (this.bestUsedTime === null) {
        this.bestUsedTime = this.elapsedTime
        this.playUpdateBestTimeAudio()
      } else {
        if (this.elapsedTime < this.bestUsedTime) {
          this.bestUsedTime = this.elapsedTime
          this.playUpdateBestTimeAudio()
        } else {
          this.bestUsedTime = this.bestUsedTime
        }
      }
    },
    checkAccuracyAndNotice () {
      return new Promise((resolve, reject) => {
        let threshold = this.currentLesson.threshold_frequency + this.currentLesson.threshold_frequency_to_mix
        let hasNoticedMsg1 = false
        // 每10轮做一次统计
        if (this.practiceTimes % (this.currentLesson.threshold_frequency / 2) === 0 &&
          this.correctTimes !== this.currentLesson.threshold_frequency) {
          let hasNoticed = []
          this.remindModalHeight = 150
          for (let pair in this.errorKeyPairs) {
            let key = pair.substring(0, 1)
            if (this.errorKeys[key]) {
              const letterErrorRate = this.errorKeys[key] / this.letterTotalCount[key]
              if (letterErrorRate >= this.currentLesson.threshold_error_rate) {
                if (this.errorKeyPairs[pair] / this.errorKeys[key] >= Number(this.currentLesson.threshold_error_rate) + 0.1 &&
                  hasNoticed.indexOf(key) < 0) {
                  const theWrongKey = pair.slice(-1)
                  this.remindErrorPairs += `<h4>${this.$t('Typing.easyToConfuse')} <b>${key}</b> ${this.$t('Common.and')} <b>${theWrongKey}</b></h4>`
                  this.remindModalHeight += 40
                  hasNoticed.push(key)
                } else if (hasNoticed.indexOf(key) < 0) {
                  this.remindErrorPairs += `<h4><b>${key}</b> ${this.$t('Typing.keyNotWellKnown')}</h4>`
                  this.remindModalHeight += 40
                  hasNoticed.push(key)
                }
              }
            }
          }
          if (this.remindErrorPairs.length > 0) {
            this.remindModalHeader = this.$t('Common.notice')
            this.remindModalBody = ''
            this.$refs.remindModal.showModal()
            this.remindModalIsHidden = false
            hasNoticedMsg1 = true
          }
        }

        // 每一次做一次统计
        if (!hasNoticedMsg1 && this.correctTimes !== this.currentLesson.threshold_frequency) {
          if (this.incorrectKeys.length === 0) {
            this.msgInPractice = `${this.$t('Typing.noticeCorrectTimes', [this.correctTimes])}`
            this.toastVariant = 'primary'
            this.$bvToast.show('inPracticeToast')
            if (this.correctTimes === 5 ||
          this.correctTimes === 10 ||
          this.correctTimes === 20) {
              this.msgInPractice = `${this.$t('Typing.giveABonus')}`
              this.toastVariant = 'primary'
              this.$bvToast.show('inPracticeToast')
            }
            const encourageText = this.encourageTexts[this.encourageTextIndex]
            if (this.correctTimes >= threshold - 5 && this.correctTimes <= threshold - 2) {
              this.msgInPractice = `${this.$t('Typing.giveAnEncourageMessage1', [threshold - this.correctTimes, encourageText])}`
              this.toastVariant = 'primary'
              this.$bvToast.show('inPracticeToast')
              this.encourageTextIndex += 1
            } else if (this.correctTimes === threshold - 1) {
              this.msgInPractice = `${this.$t('Typing.giveAnEncourageMessage2', [threshold - this.correctTimes, encourageText])}`
              this.toastVariant = 'primary'
              this.$bvToast.show('inPracticeToast')
              this.encourageTextIndex += 1
            }
          } else if ((this.practiceTimes === 1 && this.incorrectKeys.length > 0) ||
          (this.practiceTimes > 1 && this.currentIncorrectHits >= this.previousIncorrectHits && this.incorrectKeys.length > 0)) {
            this.msgInPractice += `${this.$t('Typing.incorrectCharactersThisTime')}`
            for (let key in this.incorrectKeys) {
              this.msgInPractice += `${this.incorrectKeys[key]}${this.$t('Common.comma')}`
            }
            this.msgInPractice = this.msgInPractice.slice(0, -1) // remove the last 、
            this.toastVariant = 'warning'
            this.$bvToast.show('inPracticeToast')
          } else if (this.practiceTimes > 1 && this.currentIncorrectHits < this.previousIncorrectHits) {
            this.msgInPractice = `${this.$t('Typing.reward')}`
            this.toastVariant = 'primary'
            this.$bvToast.show('inPracticeToast')
          }
        }

        // 练习结束
        if (this.correctTimes === this.currentLesson.threshold_frequency + this.currentLesson.threshold_frequency_to_mix) {
          let correctRate = Number((this.correctHits / (this.correctHits + this.incorrectHits)).toFixed(4))
          this.$store.dispatch('typing/submitTypingCombineIntermediateRecord', {
            lesson_id: this.currentLesson.lesson_id,
            practice_times: this.practiceTimes,
            correct_times: this.correctTimes,
            hit_count: this.correctHits + this.incorrectHits,
            correct_hit_count: this.correctHits,
            correct_rate: correctRate,
            best_used_time: this.bestUsedTime,
            complete_used_time: Number(this.completeUsedTime.toFixed(1))
          }).then(() => {
            this.headerText = this.$t('Typing.currentPracticeResult')
            this.displayScore =
                this.$t('Typing.correctRate') +
                roundDecimal(correctRate * 100, 2) +
                '%'
            this.$refs.scoreModal.showModal(this.infoFields)
            this.playUpdateBestTimeAudio()
            this.clearModalIsHidden = false
            resolve()
          })
        } else {
          resolve()
        }
      })
    },
    showAskLeaveModal () {
      this.remindModalHeader = this.$t('Common.notice')
      this.remindModalBody = this.$t('Common.askLeave')
      this.$refs.askLeaveModal.showModal()
      this.askLeaveModalIsHidden = false
    },
    closeAskLeaveModal () {
      this.$refs.askLeaveModal.closeModal()
      this.askLeaveModalIsHidden = true
    },
    endAndLeave () {
      let correctRate = 0
      if ((this.correctHits + this.incorrectHits) !== 0) {
        correctRate = Number((this.correctHits / (this.correctHits + this.incorrectHits)).toFixed(4))
        this.$store.dispatch('typing/submitTypingCombineIntermediateRecord', {
          lesson_id: this.currentLesson.lesson_id,
          practice_times: this.practiceTimes,
          correct_times: this.correctTimes,
          hit_count: this.correctHits + this.incorrectHits,
          correct_hit_count: this.correctHits,
          correct_rate: correctRate,
          best_used_time: this.bestUsedTime === null || this.bestUsedTime === 0 ? 9999999 : this.bestUsedTime,
          complete_used_time: this.completeUsedTime === 0 ? 0 : Number(this.completeUsedTime.toFixed(1))
        }).then(() => {
          this.askBeforeLeave = false
          this.$router.replace({ path: '/typing' })
        // window.location.reload()
        })
      } else {
        this.askBeforeLeave = false
        this.$router.replace({ path: '/typing' })
      }
    },
    clearModalMessage () {
      this.$refs.remindModal.closeModal()
      this.remindModalIsHidden = true
      this.remindErrorPairs = ''
      this.errorKeys = {}
      this.errorKeyPairs = {}
      this.letterTotalCount = {}
    },
    startTimer () {
      const timer = this.timer
      if (timer && timer.clear) {
        return
      }
      this.timer = accurateInterval(
        () => { (this.timeElapsed += TIMER_STEP) },
        TIMER_STEP,
        { aligned: true }
      )
    },
    stopTimer () {
      const timer = this.timer
      if (timer && timer.clear) {
        timer.clear()
      }
      this.timer = null
    },
    hideRemindModal () {
      this.$refs.remindModal.closeModal()
      this.remindModalIsHidden = true
    },
    backToMenuHandler () {
      this.$refs.scoreModal.closeModal()
      this.clearModalIsHidden = true
      this.askBeforeLeave = false
      this.$router.replace({ path: '/typing' })
    //   window.location.reload()
    },
    nextLevelHandler () {
      const lessonId = this.currentLesson.lesson_id
      this.askBeforeLeave = false
      this.$store.dispatch('typing/fetchLesson', {
        lesson_category: 'combine_advanced',
        lesson_id: lessonId
      }).then((response) => {
        this.$router.replace({
          name: 'typingCombineAdvanced',
          params: { lessonId: response.lesson_id, currentLesson: response }
        })
      })
    },
    playUpdateBestTimeAudio () {
      const audio = new SafeAudio(require('@/assets/Typing/SoundEffects/update-best-time.mp3'))
      audio.play()
      delete audio.audio
    },
    playIncorrectSound () {
      const audio = new SafeAudio(require('@/assets/Typing/SoundEffects/typing-incorrect.mp3'))
      audio.play()
      delete audio.audio
    },
    playVideo (path) {
      if (path && path.length > 0) {
        this.$store.dispatch('ossUtil/getSignedUrl', { path: path })
          .then((response) => {
            this.videoUrl = response
          })
        this.toShowVideo = true
      }
    },
    closeVideo () {
      this.toShowVideo = false
      this.videoUrl = ''
    }
  }
})

export default TypingCombineIntermediate
</script>

<style lang='scss' scoped>
@import "../styles/typingBasicIntermediateStyles.scss";
</style>
